/*
 * @Author: pengyong
 * @Date: 2020-11-09 15:43:19
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-01 23:49:51
 * @Description:
 * @FilePath: /exhibit/src/main.js
 */
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import { i18n } from "./lang/index.js";
import { regionDataPlus } from 'element-china-area-data';
import 'element-ui/lib/theme-chalk/index.css' ;
import "./utils/index";
import "./plugin/element";
import "./styles/reset.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import axios from 'axios'
// import 'video.js/dist/video-js.css';
// import VueVideoPlayer from 'vue-video-player'
// import 'video.js/dist/video-js.css'
// import 'videojs-flash'
// import hls from 'videojs-contrib-hls'
import './styles/iconfont.css'
import { isMobile } from './utils/encrypt'
import Vant from 'vant';
import { Notify } from 'vant';
import { Notification } from 'element-ui';
import 'vant/lib/index.css';
import 'mint-ui/lib/style.css'
import Mint from 'mint-ui'
import qs from 'qs'




// 指令
import { directive as onClickaway } from "vue-clickaway";
Vue.directive("on-clickaway", onClickaway);

// Vue.use(VueVideoPlayer)
// Vue.use(hls)
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper /* { default options with global component } */);
Vue.use(ElementUI)
Vue.use(Vant)
Vue.use(Mint);
Vue.prototype.$notify = Notify;
Vue.prototype.$qs = qs
Vue.prototype.$http = axios
Vue.use(regionDataPlus)

router.beforeEach(async(to, from, next) => {
    // if (to.meta.title) {
    //     document.title = to.meta.title
    // }else {
    //     document.title = '全球数字贸易云展会平台'
    // }

    if(window.location.href.indexOf('https://www.zhoushanexpo.com/') > -1) {
        document.title = '舟展汇';
    }else {
        document.title = '全球数字贸易云展会平台'
    }

    let clientDevice = isMobile();
    // 首页适配
    let path = to.path
    if(path == '/islandZhouShan' || path == '/exhibition' || path == '/mobileExhibition'){
        const params = qs.parse(window.location.href.split('?')[1]);
        
        const { authcode } = params;
        console.log(authcode,'authcode')
        if(authcode){
            Notification({
                title: '提示',
                message: '请在浙政钉-系统设置开启WebGL支持，重启浙政钉后生效',
                duration: 0
            });
        }else{
            if(path == '/exhibition') {
                if (clientDevice) {
                    path = path.replace('/exhibition', '/mobileExhibition')
                    next({path: path})
                } else {
                    if(window.location.href.indexOf('https://www.zhoushanexpo.com/') > -1) {
                        next({path: '/exhibitionView?exhibitionId=33'})
                    }else {
                        next()
                    } 
                }
            }else if(path == '/mobileExhibition') {
                if (clientDevice) {
                    if(window.location.href.indexOf('https://www.zhoushanexpo.com/') > -1) {
                        next({path: '/mobileIslandZhouShan?exhibition_id=33'})
                    }else {
                        next()
                    }
                } else {
                    let path = path.replace('/mobileExhibition', '/exhibition')
                    next({path: path})
                }
            }else {
                next()
            }
        }
    }else {
        next()
    }
})
axios.interceptors.request.use(function(config){
    store.state.show=true; //在请求发出之前进行一些操作
    return config
})
//定义一个响应拦截器
axios.interceptors.response.use(function(config){
    store.state.show=false;//在这里对返回的数据进行处理
    return config
})

/* eslint-disable no-new */
let vm = new Vue({
    el: "#app",
    router,
    store,
    i18n,
    render: (h) => h(App)
});
export default vm;



// WEBPACK FOOTER //
// ./src/main.js